import { render, staticRenderFns } from "./PaymentAlertPage.vue?vue&type=template&id=4b56496c&"
import script from "./PaymentAlertPage.vue?vue&type=script&lang=js&"
export * from "./PaymentAlertPage.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAlertPage.vue?vue&type=style&index=0&id=4b56496c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports